const target = '.anchor-link';
const offset = 100;
const duration = 1000;
jQuery(document).on('ready', function () {
    jQuery(target).click(function () {
        if (jQuery(this).hasClass('wp-block-button')) {
            var href = jQuery(this).find('.wp-block-button__link').attr('href');
        }
        else if (jQuery(this).hasClass('menu-item')) {
            var href = jQuery(this).find('a').attr('href');
            href = '#' + href.split('#')[1];
        }
        else {
            var href = jQuery(this).attr('href');
        }
        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery(href).offset().top - offset
        }, duration);
    });
});
